import { pathMap } from '@/navigation/paths';
import { Info, OpenInBrowser } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const NavigateToDeckExerciseButton = (props: { deckId: string; exerciseId: string }) => {
  const { deckId, exerciseId } = props;
  const navigate = useNavigate();

  return (
    <Tooltip title="Navigate to the Deck screen and display this exercise.">
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          navigate(`${pathMap.Exercises}/${deckId}?exerciseId=${exerciseId}`);
        }}
      >
        <Info />
      </IconButton>
    </Tooltip>
  );
};

export const NavigateToDeckExerciseInExtraWindowButton = (props: { deckId: string; exerciseId: string }) => {
  const { exerciseId, deckId } = props;
  return (
    <Tooltip title="Navigate to the Deck screen and display this exercise in a separate window.">
      <IconButton href={`${pathMap.Exercises}/${deckId}?exerciseId=${exerciseId}`} target="_blank">
        <OpenInBrowser />
      </IconButton>
    </Tooltip>
  );
};
